/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".other-input[_ngcontent-%COMP%]{border:0;outline:0;background:transparent;border-bottom:1px solid #2b2e34;display:inline-block;padding-left:6px!important}.other-input[_ngcontent-%COMP%]:focus, .other-input[_ngcontent-%COMP%]:hover{border-bottom:1px solid #7f1f90!important}.nowrap[_ngcontent-%COMP%]{white-space:nowrap}"];
export { styles as styles };

